import AdsumSearch from './src/AdsumSearch';

export default AdsumSearch;


// WEBPACK FOOTER //
// ./node_modules/@adactive/arc-search/index.js